import { Component } from '@angular/core';
import { Navbar } from '../../sections/navbars/navbar/navbar';
import { RouterOutlet } from '@angular/router';
import { Footer } from '../../sections/footers/footer/footer';

@Component({
  selector: 'app-main-layout',
  imports: [Navbar, RouterOutlet, Footer],
  templateUrl: './main-layout.html',
  styleUrl: './main-layout.scss',
})
export class MainLayout {}
